webpackJsonp([10],{

/***/ 958:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(959);
	
	var _perfectScrollbar = __webpack_require__(852);
	
	var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);
	
	__webpack_require__(873);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var WindowBox = (function (_Component) {
	  _inherits(WindowBox, _Component);
	
	  function WindowBox(props) {
	    _classCallCheck(this, WindowBox);
	
	    _get(Object.getPrototypeOf(WindowBox.prototype), 'constructor', this).call(this, props);
	  }
	
	  _createClass(WindowBox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var isOverflow = this.props.isOverflow;
	
	      if (isOverflow) {
	        _perfectScrollbar2['default'].initialize(this.refs.window);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var isOverflow = this.props.isOverflow;
	
	      if (isOverflow) {
	        _perfectScrollbar2['default'].initialize(this.refs.window);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var onClose = _props.onClose;
	      var width = _props.width;
	      var height = _props.height;
	      var isOverflow = _props.isOverflow;
	      var winTitleClass = _props.winTitleClass;
	      var isShowCloseBtn = _props.isShowCloseBtn;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'window-container' },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: (0, _classnames2['default'])('window', { 'window_overflow': isOverflow }),
	            ref: 'window',
	            style: {
	              width: width ? width : 600,
	              height: height ? height : 'auto'
	            }
	          },
	          _react2['default'].createElement(
	            'div',
	            { className: winTitleClass ? winTitleClass : 'window-title' },
	            _react2['default'].createElement(
	              'h1',
	              null,
	              title
	            ),
	            isShowCloseBtn && _react2['default'].createElement(
	              'button',
	              { className: 'btn window-title-button', onClick: onClose },
	              _react2['default'].createElement(
	                'span',
	                { className: 'fa-stack fa-lg' },
	                _react2['default'].createElement('i', { className: 'fa fa-circle fa-stack-1x fa-inverse window_inverse', style: { fontSize: '1.2em' } }),
	                _react2['default'].createElement('i', { className: 'fa fa-circle fa-stack-1x', style: { color: '#8ABFE5' } }),
	                _react2['default'].createElement('i', { className: 'fa fa-times fa-stack-1x', style: { color: '#157FCC', fontSize: '0.59em' } })
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'new-window-body' },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return WindowBox;
	})(_react.Component);
	
	exports['default'] = WindowBox;
	
	WindowBox.propTypes = {
	  title: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  winTitleClass: _propTypes2['default'].string,
	  children: _propTypes2['default'].object.isRequired,
	  onClose: _propTypes2['default'].func.isRequired,
	  onConfirm: _propTypes2['default'].func,
	  onCancel: _propTypes2['default'].func,
	  width: _propTypes2['default'].number,
	  height: _propTypes2['default'].number,
	  isOverflow: _propTypes2['default'].bool,
	  isShowCloseBtn: _propTypes2['default'].bool
	};
	WindowBox.defaultProps = {
	  isOverflow: false,
	  isShowCloseBtn: true
	};
	module.exports = exports['default'];

/***/ },

/***/ 959:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(960);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 960:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".window-container{position:fixed;background-color:rgba(0,0,0,.5);top:0;left:0;bottom:0;right:0;z-index:12}.window{width:600px;border-radius:5px;background-color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);-webkit-transform:translate(-50%, -50%);-moz-transform:translate(-50%, -50%);margin:0;padding:0;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.window_overflow{max-height:90%;overflow-y:auto}.ps-scrollbar-y-rail{top:40px!important;height:95%!important}.ps-scrollbar-y{height:100%!important}.ps-scrollbar-x,.ps-scrollbar-x-rail{display:none}.window-title{position:relative;background-color:#157fcc;color:#fff;border-radius:5px 5px 0 0}.window-title h1{margin:0;font-size:1rem;padding:9pt 10px 10px}.window-title-button{position:absolute;background-color:transparent;top:50%;right:0;transform:translateY(-50%);margin:0;padding:0}.window-actions{padding:10px}.window-actions button{margin-left:5px}.window-actions .btn-primary{background-color:#131c39;border-color:#121931}.window-actions .btn-primary:hover{background-color:#081850;border-color:#121931}.window_inverse{color:#157fcc}.times_circle{background-color:#157fcc;opacity:.5}.windows_buttons{padding-bottom:5px;padding-top:5px}.hr_line{border-top:1px solid #ccc;margin-bottom:5px;margin-top:30px}.loadingscreen-container{position:fixed;background-color:rgba(0,0,0,.3);top:0;left:0;bottom:0;right:0;z-index:10}.loadingscreen{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);-webkit-transform:translate(-50%, -50%);-moz-transform:translate(-50%, -50%);margin:0;padding:0}", ""]);
	
	// exports


/***/ },

/***/ 961:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(962);
	
	var MessageForm = (function (_Component) {
	  _inherits(MessageForm, _Component);
	
	  function MessageForm() {
	    _classCallCheck(this, MessageForm);
	
	    _get(Object.getPrototypeOf(MessageForm.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(MessageForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var onConfirm = _props.onConfirm;
	      var MessageText = _props.MessageText;
	      var isLoading = _props.isLoading;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'label',
	          { className: 'message_text' },
	          _react2['default'].createElement(
	            'div',
	            null,
	            MessageText
	          )
	        ),
	        _react2['default'].createElement('hr', { className: 'message_hr_line' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-group' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-12 message__btngrounp' },
	            this.props.onCancel && _react2['default'].createElement(
	              'button',
	              { onClick: this.props.onCancel, className: 'btn btn-default pull-right message__btnGrounp-btn', disabled: isLoading },
	              '取消'
	            ),
	            _react2['default'].createElement(
	              'button',
	              { onClick: onConfirm, className: 'btn btn-default pull-right message__btnGrounp-btn', disabled: isLoading },
	              isLoading ? _react2['default'].createElement('i', { className: 'fa fa-spinner fa-pulse' }) : this.props.onConfirmName || '確定'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MessageForm;
	})(_react.Component);
	
	exports['default'] = MessageForm;
	
	MessageForm.propTypes = {
	  onConfirmName: _propTypes2['default'].string,
	  onCancel: _propTypes2['default'].func,
	  onConfirm: _propTypes2['default'].func,
	  MessageText: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  isLoading: _propTypes2['default'].bool
	};
	module.exports = exports['default'];

/***/ },

/***/ 962:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(963);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 963:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".message_text{font-size:1rem;font-weight:400;color:#333;margin:30px 25px}.message__btngrounp{text-align:center;padding-bottom:5px}.message__btnGrounp-btn{min-width:75px;font-size:1rem;color:#777;margin-left:10px}.message_hr_line{border-top:1px solid #ccc;margin-bottom:6px;margin-top:0}", ""]);
	
	// exports


/***/ },

/***/ 1438:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(881);
	
	var _componentsPersonalStatus = __webpack_require__(1439);
	
	var _componentsPersonalStatus2 = _interopRequireDefault(_componentsPersonalStatus);
	
	__webpack_require__(1445);
	
	var _configsUrl = __webpack_require__(488);
	
	var _reactRedux = __webpack_require__(642);
	
	var _reducersContentReducer = __webpack_require__(497);
	
	var _reducersPersonalImgReducer = __webpack_require__(498);
	
	var _reducersFieldSettingsReducer = __webpack_require__(499);
	
	var _lodash = __webpack_require__(388);
	
	var _componentsUploadPersonalImgForm = __webpack_require__(1447);
	
	var _componentsUploadPersonalImgForm2 = _interopRequireDefault(_componentsUploadPersonalImgForm);
	
	var _componentsMessageForm = __webpack_require__(961);
	
	var _componentsMessageForm2 = _interopRequireDefault(_componentsMessageForm);
	
	var _componentsWindowBox = __webpack_require__(958);
	
	var _componentsWindowBox2 = _interopRequireDefault(_componentsWindowBox);
	
	var _reducers = __webpack_require__(496);
	
	var _reducersParamsReducer = __webpack_require__(516);
	
	var _reactIntl = __webpack_require__(818);
	
	var messages = (0, _reactIntl.defineMessages)({
	  fileUpdateError: {
	    id: 'SH_UploadFailed',
	    defaultMessage: '檔案上傳失敗'
	  }
	});
	
	var MyData = (function (_Component) {
	  _inherits(MyData, _Component);
	
	  function MyData(props) {
	    _classCallCheck(this, MyData);
	
	    _get(Object.getPrototypeOf(MyData.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      openUploadForm: false,
	      personalPicture: _configsUrl.NEWTUBE_API_SERVER + 'users/personalPicture',
	      message: ''
	    };
	    this.onShowUploadForm = this.onShowUploadForm.bind(this);
	    this.onCloseUploadForm = this.onCloseUploadForm.bind(this);
	    this.onCloseUploadForm = this.onCloseUploadForm.bind(this);
	    this.onUploadPersonaImg = this.onUploadPersonaImg.bind(this);
	  }
	
	  _createClass(MyData, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.initialize();
	      this.props.fetchUserContent();
	      this.props.fetchFieldSettings();
	      this.props.fetchParams();
	    }
	  }, {
	    key: 'onShowUploadForm',
	    value: function onShowUploadForm(event) {
	      event.preventDefault();
	      this.setState({
	        openUploadForm: true
	      });
	    }
	  }, {
	    key: 'onUploadPersonaImg',
	    value: function onUploadPersonaImg(values) {
	      var _this = this;
	
	      var formData = new FormData();
	      formData.append('Picture', values.picture);
	      return this.props.updateImg(formData).then(function () {
	        _this.setState({ openUploadForm: false });
	        // 檔案上傳成功後，直接用上傳的檔案來顯示大頭貼，避免要求Refresh才能更新大頭貼
	        var reader = new FileReader();
	        reader.onload = (function onload(e) {
	          this.setState({ personalPicture: e.target.result });
	        }).bind(_this);
	        reader.readAsDataURL(values.picture);
	        Promise.resolve();
	      }, function () {
	        _this.setState({ message: _this.props.intl.formatMessage(messages.fileUpdateError), openUploadForm: false });
	        Promise.reject();
	      });
	    }
	  }, {
	    key: 'onCloseUploadForm',
	    value: function onCloseUploadForm(event) {
	      event.preventDefault();
	      this.setState({
	        openUploadForm: false
	      });
	    }
	  }, {
	    key: 'renderMessageBox',
	    value: function renderMessageBox() {
	      var _this2 = this;
	
	      var message = this.state.message;
	      if (message && message.length > 0) {
	        return _react2['default'].createElement(
	          _componentsWindowBox2['default'],
	          {
	            title: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_Message', defaultMessage: '訊息' })],
	            onClose: function () {
	              _this2.setState({ message: '' });
	            }, width: 250
	          },
	          _react2['default'].createElement(_componentsMessageForm2['default'], {
	            MessageText: this.state.message,
	            onConfirm: function () {
	              _this2.setState({ message: '' });
	            }
	          })
	        );
	      }
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'mydata clearfix' },
	        this.renderMessageBox(),
	        this.state.openUploadForm && _react2['default'].createElement(_componentsUploadPersonalImgForm2['default'], {
	          onClose: this.onCloseUploadForm,
	          onSubmit: this.onUploadPersonaImg
	        }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-3' },
	          _react2['default'].createElement(_componentsPersonalStatus2['default'], {
	            onFileItemClick: this.onShowUploadForm,
	            onContentChange: (0, _lodash.debounce)(this.props.updateUserContent, 500),
	            content: this.props.mydata.content,
	            photoImgUrl: this.state.personalPicture
	          })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-9 mydata-edit-container' },
	          _react2['default'].createElement(
	            'ul',
	            { className: 'tab-container' },
	            _react2['default'].createElement(
	              'li',
	              { className: 'tab' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/Foundation/mydata/basicinfo', activeClassName: 'active' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_EmpInformation', defaultMessage: '基本資料' })
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              { className: 'tab' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/Foundation/mydata/contactinfo', activeClassName: 'active' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_ContactInformation', defaultMessage: '通訊資料' })
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              { className: 'tab' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/Foundation/mydata/certificationandeducationinfo', activeClassName: 'active' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'FD_EducationCertificate', defaultMessage: '學歷證照' })
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              { className: 'tab' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/Foundation/mydata/workexpinfo', activeClassName: 'active' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_WorkHistory', defaultMessage: '工作經歷' })
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              { className: 'tab' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/Foundation/mydata/seniorityinfo', activeClassName: 'active' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'FD_ServiceYear', defaultMessage: '年資' })
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              { className: 'tab' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/Foundation/mydata/jobchangeinfo', activeClassName: 'active' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_AssignmentHistory', defaultMessage: '職務經歷' })
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'clearfix' },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return MyData;
	})(_react.Component);
	
	MyData.propTypes = {
	  children: _propTypes2['default'].object,
	  mydata: _propTypes2['default'].object,
	  fetchUserContent: _propTypes2['default'].func.isRequired,
	  updateUserContent: _propTypes2['default'].func.isRequired,
	  updateImg: _propTypes2['default'].func.isRequired,
	  fetchFieldSettings: _propTypes2['default'].func.isRequired,
	  initialize: _propTypes2['default'].func.isRequired,
	  fetchParams: _propTypes2['default'].func.isRequired,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    mydata: state.app.foundation.mydata
	  };
	}
	
	MyData = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchUserContent: _reducersContentReducer.fetchUserContent,
	  updateUserContent: _reducersContentReducer.updateUserContent,
	  updateImg: _reducersPersonalImgReducer.updateImg,
	  fetchFieldSettings: _reducersFieldSettingsReducer.fetchFieldSettings,
	  initialize: _reducers.initialize,
	  fetchParams: _reducersParamsReducer.fetchParams
	})(MyData);
	exports['default'] = (0, _reactIntl.injectIntl)(MyData);
	module.exports = exports['default'];

/***/ },

/***/ 1439:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1440);
	
	var _reactIntl = __webpack_require__(818);
	
	var _componentsProfilePicture = __webpack_require__(1442);
	
	var _componentsProfilePicture2 = _interopRequireDefault(_componentsProfilePicture);
	
	var messages = (0, _reactIntl.defineMessages)({
	  sendMsg: {
	    id: 'FD_PlsEnterStatusMessage',
	    defaultMessage: '請輸入您的動態訊息'
	  }
	});
	
	var PersonalStatus = (function (_Component) {
	  _inherits(PersonalStatus, _Component);
	
	  function PersonalStatus(props) {
	    _classCallCheck(this, PersonalStatus);
	
	    _get(Object.getPrototypeOf(PersonalStatus.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      content: props.content.content
	    };
	
	    this.onInputChange = this.onInputChange.bind(this);
	  }
	
	  _createClass(PersonalStatus, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.content && this.state.content !== nextProps.content.content) {
	        this.setState({
	          content: nextProps.content.content
	        });
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(event) {
	      this.setState({ content: event.target.value });
	      if (this.props.onContentChange) {
	        this.props.onContentChange(event.target.value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var photoImgUrl = _props.photoImgUrl;
	      var content = _props.content;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'personal-status' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'image-container' },
	          _react2['default'].createElement(_componentsProfilePicture2['default'], {
	            className: 'personal-status__picture',
	            loadedPicture: photoImgUrl
	          })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'uploader-btn', onClick: this.props.onFileItemClick },
	          _react2['default'].createElement('i', { className: 'fa fa-camera', 'aria-hidden': 'true', style: { marginRight: 5 } }),
	          _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'FD_ChangePhoto', defaultMessage: '更改個人大頭照' })
	        ),
	        _react2['default'].createElement(
	          'form',
	          { className: 'content-form' },
	          _react2['default'].createElement('input', {
	            type: 'text',
	            className: 'form-control',
	            placeholder: this.props.intl.formatMessage(messages.sendMsg),
	            value: this.state.content,
	            onChange: this.onInputChange
	          }),
	          _react2['default'].createElement('i', {
	            className: (0, _classnames2['default'])({
	              'fa': true,
	              'fa-spinner': content.isUpdating,
	              'fa-spin': true
	            })
	          })
	        )
	      );
	    }
	  }]);
	
	  return PersonalStatus;
	})(_react.Component);
	
	PersonalStatus.propTypes = {
	  photoImgUrl: _propTypes2['default'].string.isRequired,
	  content: _propTypes2['default'].object.isRequired,
	  onContentChange: _propTypes2['default'].func.isRequired,
	  onFileItemClick: _propTypes2['default'].func.isRequired,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	exports['default'] = (0, _reactIntl.injectIntl)(PersonalStatus);
	module.exports = exports['default'];

/***/ },

/***/ 1440:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1441);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1441:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".personal-status .image-container{height:10pc;width:10pc;background-color:#efefef;margin:0 auto;position:relative}.personal-status .image-container img{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.personal-status .content-form{position:relative}.personal-status .content-form input{margin-top:10px;padding-right:20px}.personal-status .content-form i{position:absolute;top:50%;margin-top:-8px;right:5px}.personal-status .uploader-btn{text-align:center;cursor:pointer;margin-top:10px,}.personal-status__picture{height:150px;width:150px;top:5px;left:5px}", ""]);
	
	// exports


/***/ },

/***/ 1442:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1443);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(192);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(388);
	
	var ProfilePicture = (function (_Component) {
	  _inherits(ProfilePicture, _Component);
	
	  _createClass(ProfilePicture, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        isPictureRemovable: _propTypes2['default'].bool,
	        removeIconDisabled: _propTypes2['default'].bool,
	        onPictureRemove: _propTypes2['default'].func,
	        // container
	        prefixCls: _propTypes2['default'].string,
	        className: _propTypes2['default'].string,
	        style: _propTypes2['default'].object,
	        // picture
	        loadedPicture: _propTypes2['default'].node.isRequired,
	        pictureAlt: _propTypes2['default'].string
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        isPictureRemovable: false,
	        removeIconDisabled: false,
	        onPictureRemove: function onPictureRemove() {},
	        prefixCls: 'profile-picture'
	      };
	    }
	  }]);
	
	  function ProfilePicture() {
	    _classCallCheck(this, ProfilePicture);
	
	    _get(Object.getPrototypeOf(ProfilePicture.prototype), 'constructor', this).call(this);
	    this.containerInst = null;
	    this.pictureInst = null;
	    this.updateStyle = this.updateStyle.bind(this);
	  }
	
	  _createClass(ProfilePicture, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = this.props;
	
	      this.updateStyle(props);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var props = this.props;
	
	      this.updateStyle(props);
	    }
	  }, {
	    key: 'updateStyle',
	    value: function updateStyle(props) {
	      var picture = (0, _reactDom.findDOMNode)(this.pictureInst);
	      if (!picture) return false;
	
	      // change width or height ratio
	      var tempImage = new Image();
	      tempImage.src = props.loadedPicture;
	      var handleTempImageLoaded = function handleTempImageLoaded(_props) {
	        var _cx;
	
	        var originalWidth = tempImage.width;
	        var originalHeight = tempImage.height;
	
	        picture.className = (0, _classnames2['default'])(_props.prefixCls + '__image', (_cx = {}, _defineProperty(_cx, _props.prefixCls + '__image--more-width', originalWidth >= originalHeight), _defineProperty(_cx, _props.prefixCls + '__image--more-height', originalHeight > originalWidth), _cx));
	        picture.src = _props.loadedPicture;
	      };
	
	      tempImage.onload = handleTempImageLoaded.bind(this, props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var props = this.props;
	      var className = props.className;
	      var prefixCls = props.prefixCls;
	      var style = props.style;
	      var pictureAlt = props.pictureAlt;
	      var isPictureRemovable = props.isPictureRemovable;
	      var removeIconDisabled = props.removeIconDisabled;
	      var onPictureRemove = props.onPictureRemove;
	
	      var divProps = Object.assign({}, props);
	
	      return _react2['default'].createElement(
	        'div',
	        _extends({}, (0, _lodash.omit)(divProps, ['isPictureRemovable', 'removeIconDisabled', 'onPictureRemove', 'loadedPicture', 'prefixCls']), {
	          className: (0, _classnames2['default'])(prefixCls, className),
	          ref: function (inst) {
	            return _this.containerInst = inst;
	          },
	          style: style
	        }),
	        _react2['default'].createElement('img', { className: prefixCls + '__image',
	          ref: function (inst) {
	            return _this.pictureInst = inst;
	          },
	          alt: pictureAlt
	        }),
	        isPictureRemovable && _react2['default'].createElement(
	          'button',
	          {
	            type: 'button',
	            disabled: removeIconDisabled,
	            className: (0, _classnames2['default'])(prefixCls + '__remove', _defineProperty({}, prefixCls + '__remove--disabled', removeIconDisabled)),
	            onClick: onPictureRemove
	          },
	          _react2['default'].createElement('i', { className: 'fa fa-times-circle ' + prefixCls + '__remove-icon', 'aria-hidden': 'true' })
	        )
	      );
	    }
	  }]);
	
	  return ProfilePicture;
	})(_react.Component);
	
	exports['default'] = ProfilePicture;
	module.exports = exports['default'];

/***/ },

/***/ 1443:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1444);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1444:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".profile-picture{position:relative;border:1px solid #ccc;border-radius:5px;background-color:#fff;overflow:hidden}.profile-picture__image{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.profile-picture__image--more-width{width:100%;height:auto}.profile-picture__image--more-height{width:auto;height:100%}.profile-picture__remove{position:absolute;top:5px;right:8px;z-index:1;display:inline-block;vertical-align:top;padding:0;margin:0;border:none;line-height:1;outline:0;background-color:transparent}.profile-picture__remove--is-disabled{opacity:.65}.profile-picture__remove-icon{font-size:18px;color:#777}.profile-picture__remove-icon:hover{color:#9b9b9b}", ""]);
	
	// exports


/***/ },

/***/ 1445:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1446);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1446:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".mydata{min-height:8in;background:#fff}.mydata .mydata-edit-container{border:1px solid #ccc;padding:15px}.mydata .tab-container{list-style:none;margin:0;padding:0;border-bottom:5px solid #efefef;margin-bottom:10px}.mydata .tab-container .tab{display:inline-block;margin-right:1px}.mydata .tab-container .tab a{display:inline-block;padding:8px 9pt 7px;font-weight:500;text-align:center;border-radius:5px 5px 0 0;color:#333;text-decoration:none}.mydata .tab-body,.mydata .tab-container .tab a.active,.mydata .tab-container .tab a:hover{background:#efefef}.mydata .tab-body{position:relative;padding-top:10px;margin-bottom:10px}.mydata .tab-body .action{position:absolute;right:10px;background-color:transparent;z-index:2}.mydata .form-control{color:#333}", ""]);
	
	// exports


/***/ },

/***/ 1447:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsWindowBox = __webpack_require__(958);
	
	var _componentsWindowBox2 = _interopRequireDefault(_componentsWindowBox);
	
	var _reduxForm = __webpack_require__(640);
	
	__webpack_require__(1448);
	
	var _reactIntl = __webpack_require__(818);
	
	var messages = (0, _reactIntl.defineMessages)({
	  selectPic: {
	    id: 'id',
	    defaultMessage: '請選擇個人大頭照'
	  },
	  fileSizeLimit: {
	    id: 'SH_FileSizeLimit',
	    defaultMessage: '大小限制為 {0}'
	  }
	});
	
	var UploadPersonalImgForm = (function (_Component) {
	  _inherits(UploadPersonalImgForm, _Component);
	
	  function UploadPersonalImgForm(props) {
	    _classCallCheck(this, UploadPersonalImgForm);
	
	    _get(Object.getPrototypeOf(UploadPersonalImgForm.prototype), 'constructor', this).call(this, props);
	    this.onFileChange = this.onFileChange.bind(this);
	  }
	
	  _createClass(UploadPersonalImgForm, [{
	    key: 'onFileChange',
	    value: function onFileChange(event) {
	      event.preventDefault();
	      if (!event.target.files || event.target.files.length === 0) {
	        return;
	      }
	      this.props.fields.picture.onChange(event.target.files[0]);
	      this.props.fields.forceUpdate.onChange(event.target.files[0].name);
	    }
	  }, {
	    key: 'renderUploadForm',
	    value: function renderUploadForm() {
	      var picture = this.props.fields.picture;
	
	      return _react2['default'].createElement(
	        _componentsWindowBox2['default'],
	        { width: 340, title: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_ChangePhoto', defaultMessage: '更改個人大頭照' })], onClose: this.props.onClose },
	        _react2['default'].createElement(
	          'div',
	          { className: 'personal-img-uploader-form' },
	          _react2['default'].createElement(
	            'form',
	            { className: 'upload-form', onSubmit: this.props.handleSubmit },
	            _react2['default'].createElement(
	              'div',
	              { className: 'input-group' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'form-control', title: picture.value && picture.value.name },
	                picture.value && picture.value.name
	              ),
	              _react2['default'].createElement(
	                'label',
	                { className: 'input-group-addon btn', htmlFor: 'uploader' },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_SelectFile', defaultMessage: '選擇檔案' })
	              )
	            ),
	            _react2['default'].createElement('input', { type: 'file', className: 'form-control', id: 'uploader', accept: 'image/*', max: '300',
	              onChange: this.onFileChange
	            }),
	            picture.dirty && picture.error && _react2['default'].createElement(
	              'span',
	              {
	                className: 'text-danger',
	                style: {
	                  margin: 15
	                }
	              },
	              picture.error
	            ),
	            _react2['default'].createElement(
	              'ul',
	              { className: 'notifications basic__helpBlock' },
	              _react2['default'].createElement(
	                'li',
	                null,
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_PicFileLimit', defaultMessage: '檔案格式限制為 JPG, JPEG, GIF, PNG' })
	              ),
	              _react2['default'].createElement(
	                'li',
	                null,
	                _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                  id: 'SH_FileSizeLimit',
	                  defaultMessage: '大小限制為 {0}',
	                  values: {
	                    0: '300KB'
	                  }
	                })
	              )
	            ),
	            _react2['default'].createElement('hr', null),
	            _react2['default'].createElement(
	              'div',
	              { className: 'action-group clearfix' },
	              _react2['default'].createElement(
	                'button',
	                { className: 'btn btn-default', onClick: this.props.onClose },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_Cancel', defaultMessage: '取消' })
	              ),
	              _react2['default'].createElement(
	                'button',
	                { className: 'btn btn-primary', disabled: picture.invalid },
	                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_Confirm', defaultMessage: '確定' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.submitting) {
	        return this.renderUploadForm();
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: 'personal-img-uploader-form loading-container' },
	        _react2['default'].createElement('span', { className: 'fa fa-spinner fa-spin fa-3x loading' })
	      );
	    }
	  }]);
	
	  return UploadPersonalImgForm;
	})(_react.Component);
	
	exports.UploadPersonalImgForm = UploadPersonalImgForm;
	
	UploadPersonalImgForm.propTypes = {
	  handleSubmit: _propTypes2['default'].func.isRequired,
	  fields: _propTypes2['default'].object.isRequired,
	  onClose: _propTypes2['default'].func.isRequired,
	  submitting: _propTypes2['default'].bool.isRequired,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	/*
	  替換要上傳檔案的時候，Props不會更新，
	  導致畫面不會顯示新的檔案名稱，
	  但是如果去更動其他欄位時，會連動更新Props,
	  所以建了個假欄位forceUpdate，讓檔案上傳的時候會更新，
	  有空再回來查是什麼原因 Orz
	 */
	
	var fields = ['picture', 'forceUpdate'];
	
	exports.fields = fields;
	var formName = 'foundation/mydata/UploadPersonalImgForm';
	
	exports.formName = formName;
	var validate = function validate(values, props) {
	  var errors = {};
	  if (!values.picture) {
	    errors.picture = props.intl.formatMessage(messages.selectPic);
	  }
	  if (values.picture && values.picture.size > 300000) {
	    errors.picture = props.intl.formatMessage(messages.fileSizeLimit, { 0: '300KB' });
	  }
	  return errors;
	};
	
	exports.UploadPersonalImgForm = UploadPersonalImgForm = (0, _reduxForm.reduxForm)({
	  form: 'foundation/mydata/UploadPersonalImgForm',
	  fields: fields,
	  validate: validate
	})(UploadPersonalImgForm);
	
	exports['default'] = (0, _reactIntl.injectIntl)(UploadPersonalImgForm);

/***/ },

/***/ 1448:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1449);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1449:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".personal-img-uploader-form .input-group{padding:10px}.personal-img-uploader-form .form-control{overflow:hidden;text-overflow:ellipsis;height:34px;white-space:nowrap;width:210px;cursor:default}.personal-img-uploader-form label{cursor:pointer}.personal-img-uploader-form input{display:none}.personal-img-uploader-form .notifications{padding-right:10px;padding-left:10px;margin:5px;margin-bottom:-15px;list-style-type:none}.personal-img-uploader-form .notifications li:before{content:' * '}.personal-img-uploader-form .btn:hover{background-color:#d6d6d6}.personal-img-uploader-form hr{background-color:#d0d0d0}.personal-img-uploader-form .action-group{margin-top:-10px;padding:0 10px 10px}.personal-img-uploader-form .action-group .btn{float:right;margin-right:5px}.personal-img-uploader-form .action-group .btn:first-child{margin-right:0}.personal-img-uploader-form.loading-container{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.3);z-index:1}.personal-img-uploader-form.loading-container .loading{position:absolute;top:50%;left:50%;color:#fff;transform:translateY(-50%)}", ""]);
	
	// exports


/***/ }

});


/** WEBPACK FOOTER **
 ** 10.chunk.f9a47f35f7613bbad604.js
 **/